import React, { useState, useEffect } from 'react'
import AsyncSelect from 'react-select/async'
import styled from 'styled-components'
import Help from '../elements/Help'
import { withContext } from '../../context/withContext'
import { FilterContacts } from '../../API/contacts'

function SearchableContact(props) {
	const [loading] = useState(false)
	const [value, setValue] = useState(props.isMulti ? [] : undefined)
	const [debounce, setDebounce] = useState(0)

	useEffect(() => {
		return () => {
			if (props.defaultValue) setValue(props.defaultValue)
		}
	}, [])

	useEffect(() => {
		if (props.defaultValue) setValue(props.defaultValue)
	}, [props.defaultValue])

	const handleChange = (element) => {
		if (props.isMulti) {
			let arr = []
			for (let x in element) {
				arr.push(element[x].value)
			}
			setValue(element)
			if (props.onChange) {
				if (props.ReactSelect) {
					props.onChange(element)
				} else {
					props.onChange(arr)
				}
			}
		} else {
			setValue(element)
			if (props.onChange && element !== null) {
				if (props.ReactSelect) {
					props.onChange(element)
				} else {
					props.onChange(element.value)
				}
			} else {
				props.onChange(null)
			}
		}
	}

	const loadOptions = (inputValue, callback) => {
		let qs = 'search=' + inputValue
		let arr = []
		let token = props.context.token
		clearTimeout(debounce)
		setDebounce(
			setTimeout(() => {
				return FilterContacts(token, qs).then((response) => {
					for (let x = 0; x < response.data.results.length; x++) {
						let data = response.data.results[x]
						arr.push({
							label: `${data.full_name}
                                    ${data.phone ? ` - ${data.phone}` : ''}
                                    ${data.email ? ` - ${data.email}` : ''}`,
							value: data.uid,
						})
					}
					return callback(arr)
				})
			}, 500)
		)
	}

	return (
		<ContentField
			error={props.required && props.showError && (value === null || value === '') ? props.showError : false}
			className={props.sm ? 'form-group-sm' : 'form-group'}>
			{props.label ? (
				<label htmlFor={props.id}>
					{props.label}: {props.required ? <span className="danger">*</span> : null}
				</label>
			) : null}
			{props.help ? <Help id={props.id} help={props.help} /> : null}
			<AsyncSelect
				isMulti={props.isMulti}
				isClearable
				value={value}
				loadedOptions={props.defaultValue}
				defaultOptions
				loadOptions={loadOptions}
				isLoading={props.isLoading}
				placeholder={props.placeholder ? props.placeholder : 'Seleccionar'}
				isDisabled={loading}
				onChange={handleChange}
				classNamePrefix="react-select"
			/>
		</ContentField>
	)
}
export default withContext(SearchableContact)

const ContentField = styled.div`
	.react-select__control {
		border-color: ${(props) => props.error && '#f00 !important'};
	}
`
